import { useState } from 'react';
import { Stack, Box } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useSelector, useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import fetchDeviceList from '../../utils/fetchDeviceList';
import fetchStreamList from '../../utils/fetchStreamList';
import { appSliceActions } from '../../appSlices/appSlice';
import axiosInstance from '../../utils/axiosInstance';
import SingleSelector from '../single-selector/singleSelector';

export default function ScanCameras() {
  const { enqueueSnackbar } = useSnackbar();
  const { adaptorType } = window;
  const dispatch = useDispatch();
  const [vstHost, setVstHost] = useState(null);
  const hostList = useSelector((state) => state.app.hostList);

  const handleSubmit = () => {
    if (!vstHost) {
      enqueueSnackbar(`Error - VST device not selected`, {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      return;
    }
    enqueueSnackbar(`Pending - scan cameras on ${vstHost}`, {
      variant: 'info',
      anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
    });
    axiosInstance
      .post(`${window.location.protocol}//${vstHost}/api/v1/sensor/scan`)
      .then(async () => {
        enqueueSnackbar(`Success - scan cameras success on ${vstHost}`, {
          variant: 'success',
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        });
        const cameraList = await fetchDeviceList(vstHost);
        if (cameraList != null) {
          for (let i = 0; i < cameraList.length; i += 1) {
            cameraList[i].host = vstHost;
          }
          dispatch(appSliceActions.addDevice(cameraList));
        }
        const streamList = await fetchStreamList(vstHost);
        if (streamList != null) {
          for (let i = 0; i < streamList.length; i += 1) {
            streamList[i].host = vstHost;
          }
          dispatch(appSliceActions.addStream(streamList));
        }
      })
      .catch((error) => {
        if (error.response.data == null)
          enqueueSnackbar(`Error - ${error.response.status}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
        else
          enqueueSnackbar(`Error - ${error.response.data.error_message}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
      });
  };

  return (
    <>
      <Stack spacing={3} sx={{ mb: 2 }}>
        <SingleSelector
          id="scan-vst"
          placeholder="Type to search"
          label={`Select ${adaptorType} device`}
          value={vstHost}
          onChange={setVstHost}
          getOptionLabel={(option) => `${adaptorType} at ${option}`}
          options={hostList}
        />
      </Stack>
      <Box m={1} display="flex" justifyContent="flex-end" alignItems="flex-end">
        <LoadingButton size="large" type="submit" variant="contained" onClick={handleSubmit}>
          Submit
        </LoadingButton>
      </Box>
    </>
  );
}
